<button [type]="type"
  [disabled]="disabled"
  [class.disabled]="disabled"
  [class.shadow-effect]="shadowEffect"
  [ngClass]="['mp-button', shape + '-shape', size + '-size', color, 'icon-' + faIconPosition, customClasses]"
  (click)="sendButtonClicked($event)">
  @if (faIcon) {
    <i class="mp-button-icon {{faIcon}}"></i>
  }
  @if (label) {
    <span class="mp-button-label">{{ label | translate }}</span>
  }
  @if (isLoading) {
    <div class="loader">
      <i class="fas fa-spin fa-circle-notch"></i>
    </div>
  }
</button>

